namespace SP.Data {
    export class Stock {
        private static stockInfos: { [stockId: string]: StockInfo } = {};
        private static halls: { [stockId: string]: StockHall[] } = {};
        private static sections: { [hallId: string]: StockSection[] } = {};
        private static units: { [sectionId: string]: StockUnit[] } = {};
        private static placements: { [unitId: string]: StockPlacement[] } = {};
        private static placementInfo: { [placementId: string]: StockPlacementInfo } = {};
        private static allStockInfos: StockInfo[];

        static async getStockInfos(useCache = true) {
            if (useCache && this.allStockInfos != null) return this.allStockInfos;
            var response = await SP.get<any>("/api/v1/info/stockInfos/");
            if (response.status == 200) {
                this.allStockInfos = response.data;
                for (let i = 0; i < this.allStockInfos.length; i++) {
                    var si = this.allStockInfos[i];
                    this.stockInfos[si.stockId] = si;
                }
            }
            else await SP.alertX(response.status + ": " + response.msg);
            return this.allStockInfos;
        }


        static async getStockInfo(stockId: string, useCache = true) {
            if (useCache && this.stockInfos[stockId] != null) return this.stockInfos[stockId];
            var response = await SP.get<any>("/api/v1/info/stockInfo/" + stockId);
            if (response.status == 200) {
                this.stockInfos[stockId] = response.data;
         
            }
            else await SP.alertX(response.status + ": " + response.msg);
            return this.stockInfos[stockId];
        }

        static async getHalls(stockId: string, useCache = true) {
            if (useCache && this.halls[stockId] != null) return this.halls[stockId];
            var response = await SP.get<any>("/api/v1/info/stockHalls/" + stockId);
            if (response.status == 200) this.halls[stockId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.halls[stockId];
        }

        static async getSections(hallId: string, useCache = true) {
            if (useCache && this.sections[hallId] != null) return this.sections[hallId];
            var response = await SP.get<any>("/api/v1/info/stockSections/" + hallId);
            if (response.status == 200) this.sections[hallId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.sections[hallId];
        }

        static async getUnits(sectionId: string, useCache = true) {
            if (useCache && this.units[sectionId] != null) return this.units[sectionId];
            var response = await SP.get<any>("/api/v1/info/stockUnits/" + sectionId);
            if (response.status == 200) this.units[sectionId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.units[sectionId];
        }

        static async getPlacements(unitId: string, useCache = true) {
            if (useCache && this.placements[unitId] != null) return this.placements[unitId];
            var response = await SP.get<any>("/api/v1/info/stockPlacements/" + unitId);
            if (response.status == 200) this.placements[unitId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.placements[unitId];
        }

        static async getPlacementInfo(placementId: number, useCache = true) {
            if (useCache && this.placementInfo[placementId] != null) return this.placementInfo[placementId];
            var response = await SP.get<any>("/api/v1/info/stockPlacementInfo/" + placementId);
            if (response.status == 200) this.placementInfo[placementId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.placementInfo[placementId];
        }
    }
}